module.exports = __webpack_public_path__ + "img/login-modal-right-image.d225e630.png";